import { render } from "./FaqItem.vue?vue&type=template&id=18213f6f"
import script from "./FaqItem.vue?vue&type=script&lang=js"
export * from "./FaqItem.vue?vue&type=script&lang=js"

import "./FaqItem.vue?vue&type=style&index=0&id=18213f6f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__